<template>
  <div>
    <span class="text-danger" v-if="object[field.id]">{{ $t('yes') }}</span>
    <span class="text-secondary" v-if="!object[field.id]">{{ $t('no') }}</span>
  </div>
</template>

<script>
export default {
  name: "SuperAdminDatatableTDNewVersion",
  props: {
    object: {
      type: Object
    },
    field: {
      type: Object
    }
  },
}
</script>
